import { asyncLoader } from "@/router/route-helper"

export default  [

    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/users/employee-profile.vue'),
        meta: { requiresAuth: true, role: 'lead' },
    },
    {
        path: '/events',
        name: 'events',
        component: () => import('@/views/apps/calendar.vue'),
        meta: { requiresAuth: true, role: 'lead' },
    },
    {
        path: '/my-points',
        name: 'my-points',
        component: () => import('@/views/employee/points/points.vue'),
        meta: { requiresAuth: true, role: 'lead' },
    },
    {
        path: '/points/add',
        name: 'add-points',
        component: () => import('@/views/points/add-or-update-points.vue'),
        meta: { requiresAuth: true, role: 'lead' },
    },
    { 
        path: '/points/redeem', 
        name: 'points-redeem', 
        component: () => import('@/views/redeem/add-or-update-redeem.vue'),
        meta: { requiresAuth: true, role: 'lead' },
    },
    { 
        path: '/points/my-redeems', 
        name: 'my-redeems', 
        component: () => import('@/views/redeem/redeem.vue'),
        meta: { requiresAuth: true, role: 'lead'},
    },
    {
        path: '/points/redeem/update/:redeem_id',
        name: 'update-redeem',
        component: () => import('@/views/redeem/add-or-update-redeem.vue'),
        meta: { requiresAuth: true, role: 'lead'  },
    },
];
